import { faUserMinus } from "@fortawesome/pro-regular-svg-icons";

import { HistorySingleEntry } from "src/cases/caseView/history/HistoryItemFrame";
import { UserPill } from "src/cases/common/UserPill";
import { CaseHistoryEvent } from "src/cases/queries/casesTypes";
import { logger } from "src/utils/logger";

export const CaseUnassigned: React.FC<{
  entry: CaseHistoryEvent<"case_unassigned">;
  isLast: boolean;
}> = ({ entry, isLast }) => {
  if (!entry.event_data.unassigned_from_user_id) {
    logger.error(
      "Unassigned from user id is required for case unassigned event",
      entry.event_data,
    );
    return null;
  }

  return (
    <HistorySingleEntry
      actorId={entry.event_data.unassigned_by_user_id}
      eventType={entry.event_type}
      headline={
        <>
          <div className="inline-block align-middle">
            <UserPill userId={entry.event_data.unassigned_from_user_id} />
          </div>{" "}
          was unassigned from the case.
        </>
      }
      icon={faUserMinus}
      isLast={isLast}
      timestamp={entry.timestamp}
    />
  );
};
